import React from "react";
import { motion } from "framer-motion";
import { FlameIcon } from "lucide-react";
import { SPOTS_CLAIMED_PERCENT, SPOTS_LEFT } from "../data/offer";
export function ScarcityBar() {
  return <div className="mx-auto mt-6 w-full max-w-xl rounded-2xl border-2 border-coral/25 bg-blush-soft p-4" data-id="element-50" data-mp="2l5fz8jmkk37e">
      <div className="flex items-start gap-2" data-id="element-51" data-mp="2q37p783nlf8y">
        <FlameIcon className="mt-0.5 h-5 w-5 shrink-0 text-coral" aria-hidden="true" data-id="element-52" data-mp="2q1wkn62dw3gs" />
        <p className="text-[15px] font-extrabold leading-snug text-ink" data-id="element-53" data-mp="2b570ay1703ob">
          Only <span className="text-coral" data-id="element-54" data-mp="2g6wcwi42cpei">{SPOTS_LEFT} spots left</span> at the $27 promotional price
        </p>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white ring-1 ring-coral/20" role="progressbar" aria-valuenow={SPOTS_CLAIMED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-55" data-mp="227wlj2p61wen">
        <motion.div className="h-full rounded-full bg-coral" initial={{
        width: "60%"
      }} whileInView={{
        width: `${SPOTS_CLAIMED_PERCENT}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-56" data-mp="5d9x322x0m4j" />
      </div>
      <div className="mt-1.5 flex justify-between text-xs font-bold text-ink/70" data-id="element-57" data-mp="3dbd5svjed86q">
        <span data-id="element-58" data-mp="38emok4vuw6jq">{SPOTS_CLAIMED_PERCENT}% claimed</span>
        <span data-id="element-59" data-mp="38fxti811fkcf">Price goes up when full</span>
      </div>
    </div>;
}